import { jsxs as c, jsx as e } from "react/jsx-runtime";
import { withManagedProps as m } from "@made-people/managed-props";
import { withZod as n } from "@made-people/react-prop-guard";
import { z as s } from "zod";
import { genericOrderReceiptProps as d } from "@made-people/grease-order";
import { useTranslate as o } from "@made-people/grease-translations";
import { o as v, p as D, s as T, a as f, b as O } from "./blueprint-1b85b4b5.mjs";
import { cartSummaryPropsSchema as u, CartSummary as h } from "@made-people/blueprint-cart-summary";
import { buttonAsLinkSchema as p, ButtonAsLink as S } from "@made-people/blueprint-button";
import "@made-people/blueprint";
const R = {
  orderNumber: "1003002386",
  currencyCode: "SEK",
  itemQuantity: 1,
  billingAddress: {
    firstName: "John",
    lastName: "Doe",
    email: "test",
    street: "1234 Test St",
    zipCode: "12345",
    city: "Test City",
    country: "Test Country",
    state: "Test State",
    phoneNumber: "123456789"
  },
  shippingAddress: {
    firstName: "John",
    lastName: "Doe",
    email: "test",
    street: "1234 Test St",
    zipCode: "12345",
    city: "Test City",
    country: "Test Country",
    state: "Test State",
    phoneNumber: "123456789"
  },
  vouchers: [],
  items: [
    {
      type: "product",
      lineId: "4719-17911",
      id: "4719",
      sku: "U9359999",
      quantity: 1,
      itemDimensions: [
        {
          dimensionKey: "Order_Summary_Size_Label",
          dimensionLabel: "Order_Receipt_Summary_Size_Label",
          value: "XXS",
          valueLabel: "XXS"
        }
      ],
      price: {
        discounted: !1,
        priceEach: {
          number: 299,
          formatted: "299 SEK"
        },
        priceEachWithoutDiscount: {
          number: 299,
          formatted: "299 SEK"
        },
        priceEachWithoutTax: {
          number: 249,
          formatted: "249 SEK"
        },
        totalPrice: {
          number: 299,
          formatted: "299 SEK"
        }
      },
      product: {}
    }
  ],
  totals: {
    subtotalWithoutTax: {
      number: 980,
      formatted: "980 SEK"
    },
    grandTotal: {
      number: 1e3,
      formatted: "1000 SEK"
    },
    shipping: {
      number: 20,
      formatted: "20 SEK"
    },
    subtotal: {
      number: 980,
      formatted: "980 SEK"
    }
  },
  status: "completed",
  date: /* @__PURE__ */ new Date("2024-12-18 10:36:49"),
  paymentMethod: "Adyen Drop-In",
  shippingMethod: "DBS Ombud Standard",
  additionalNotes: ""
}, j = s.custom().and(
  s.object({
    variants: s.custom().optional()
  })
), b = n(j, ({ order: t }) => {
  const r = o(), a = v.styles();
  return /* @__PURE__ */ c("dl", { className: a.base, "aria-labelledby": "order-details-heading", children: [
    /* @__PURE__ */ e("h2", { id: "order-details-heading", className: a.hiddenLabel, children: r("SuccessPage_OrderDetails_Heading") }),
    /* @__PURE__ */ c("div", { "data-label": "date", className: a.row, children: [
      /* @__PURE__ */ e("dt", { className: a.label, children: r("Success_Page_Order_Details_Date") }),
      /* @__PURE__ */ e("dd", { className: a.item, children: t.date.toISOString().slice(0, 19).replace("T", " ") })
    ] }),
    /* @__PURE__ */ c("div", { "data-label": "status", className: a.row, children: [
      /* @__PURE__ */ e("dt", { className: a.label, children: r("Success_Page_Order_Details_Status") }),
      /* @__PURE__ */ e("dd", { className: a.item, children: t.status })
    ] }),
    /* @__PURE__ */ c("div", { "data-label": "payment-method", className: a.row, children: [
      /* @__PURE__ */ e("dt", { className: a.label, children: r("Success_Page_Order_Details_Payment_Method") }),
      /* @__PURE__ */ e("dd", { className: a.item, children: t.paymentMethod })
    ] })
  ] });
}), E = s.custom().and(
  s.object({
    variants: s.custom().optional()
  })
), g = n(E, ({ order: t }) => {
  const r = o(), a = D.styles();
  return t.totals.discount, /* @__PURE__ */ c("dl", { className: a.base, "aria-labelledby": "payment-details-heading", children: [
    /* @__PURE__ */ e("h2", { id: "payment-details-heading", className: a.hiddenLabel, children: r("SuccessPage_PaymentDetails_Heading") }),
    /* @__PURE__ */ c("div", { "data-label": "shipping", className: a.row, children: [
      /* @__PURE__ */ e("dt", { className: a.label, children: r("Success_Page_Payment_Details_Shipping") }),
      /* @__PURE__ */ e("dd", { className: a.item, children: t.totals.shipping.formatted })
    ] }),
    /* @__PURE__ */ c("div", { "data-label": "total", className: a.row, children: [
      /* @__PURE__ */ e("dt", { className: a.label, children: r("Success_Page_Payment_Details_Total") }),
      /* @__PURE__ */ e("dd", { className: a.item, children: t.totals.grandTotal.formatted })
    ] })
  ] });
}), P = s.object({
  order: d.shape.order.optional(),
  variants: s.custom().optional(),
  features: s.object({
    linkVariants: p.shape.variants.optional(),
    cartSummarySettings: u.shape.templateProps.optional()
  }).optional()
}), L = m(
  "SuccessPageBarcelona",
  n(P, ({ order: t, variants: r, features: a }) => {
    const i = o(), l = T.styles(r);
    return t ? /* @__PURE__ */ c("div", { className: l.base, children: [
      /* @__PURE__ */ e("h1", { className: l.heading, children: i("Success_Page_Heading") }),
      /* @__PURE__ */ e("span", { className: l.orderNumberLabel, children: i("Succes_Page_Order_Number_Label") }),
      /* @__PURE__ */ e("span", { className: l.orderNumber, children: t.orderNumber }),
      /* @__PURE__ */ e("p", { className: l.body, children: i("Success_Page_Body", {
        email: t.billingAddress.email
      }) }),
      /* @__PURE__ */ e("div", { className: l.button, children: /* @__PURE__ */ e(
        S,
        {
          variants: a == null ? void 0 : a.linkVariants,
          label: i("Success_Page_Button_Label")
        }
      ) }),
      /* @__PURE__ */ c("div", { className: l.cartSummaryWrapper, children: [
        /* @__PURE__ */ e("h3", { className: l.cartSummaryHeading, children: i("Success_Page_Payment_Order_Summary") }),
        /* @__PURE__ */ e(
          h,
          {
            templateProps: {
              template: "birch",
              cartItemsSettings: {
                items: t.items,
                itemSettings: {
                  templateProps: {
                    template: "tokyo",
                    editable: !1
                  }
                }
              },
              cartTotalsSettings: {
                hide: !0
              },
              ...a == null ? void 0 : a.cartSummarySettings
            }
          }
        )
      ] }),
      /* @__PURE__ */ e(b, { order: t }),
      /* @__PURE__ */ e(g, { order: t })
    ] }) : null;
  })
), _ = s.object({
  order: d.shape.order.optional(),
  variants: s.custom().optional(),
  features: s.object({
    linkVariants: p.shape.variants.optional()
  }).optional()
}), k = m(
  "SuccessPageMadrid",
  n(_, ({ order: t, variants: r, features: a }) => {
    const i = o(), l = f.styles(r);
    return t ? /* @__PURE__ */ e("div", { className: l.base, children: i("Success_Page_Heading") }) : null;
  })
), y = s.object({
  order: d.shape.order.optional(),
  variants: s.custom().optional(),
  features: s.object({
    linkVariants: p.shape.variants.optional(),
    cartSummarySettings: u.shape.templateProps.optional()
  }).optional()
}), B = m(
  "SuccessPagePalma",
  n(y, ({ order: t, variants: r, features: a }) => {
    const i = o(), l = O.styles(r);
    return t ? /* @__PURE__ */ c("div", { className: l.base, children: [
      /* @__PURE__ */ e("h1", { className: l.heading, children: i("Success_Page_Heading") }),
      /* @__PURE__ */ e("p", { className: l.body, children: i("Success_Page_Body", {
        email: t.billingAddress.email
      }) }),
      /* @__PURE__ */ e("span", { className: l.orderNumber, children: i("Success_Page_Order_Number", {
        orderNumber: t.orderNumber
      }) }),
      /* @__PURE__ */ e("div", { className: l.button, children: /* @__PURE__ */ e(
        S,
        {
          variants: a == null ? void 0 : a.linkVariants,
          label: i("Success_Page_Button_Label")
        }
      ) }),
      /* @__PURE__ */ c("div", { className: l.cartSummaryWrapper, children: [
        /* @__PURE__ */ e("h3", { className: l.cartSummaryHeading, children: i("Success_Page_Payment_Order_Summary") }),
        /* @__PURE__ */ e(
          h,
          {
            templateProps: {
              template: "birch",
              cartItemsSettings: {
                items: t.items,
                itemSettings: {
                  templateProps: {
                    template: "tokyo",
                    editable: !1
                  }
                }
              },
              cartTotalsSettings: {
                hide: !0
              },
              ...a == null ? void 0 : a.cartSummarySettings
            }
          }
        ),
        /* @__PURE__ */ e(b, { order: t }),
        /* @__PURE__ */ e(g, { order: t })
      ] })
    ] }) : null;
  })
), N = s.discriminatedUnion("template", [
  P.merge(
    s.object({ template: s.literal("barcelona") })
  ),
  _.merge(
    s.object({ template: s.literal("madrid") })
  ),
  y.merge(
    s.object({ template: s.literal("palma") })
  )
]), K = n(N, (t) => {
  switch (t.template) {
    case "barcelona":
      return /* @__PURE__ */ e(L, { ...t });
    case "madrid":
      return /* @__PURE__ */ e(k, { ...t });
    case "palma":
      return /* @__PURE__ */ e(B, { ...t });
    default:
      return null;
  }
}), w = "barcelona", M = s.object({
  templateProps: N.optional(),
  order: d.shape.order.optional()
}), U = m(
  "SuccessPage",
  n({ schema: M, defaultProps: {} }, (t) => {
    const r = t.templateProps || {
      template: w
    };
    return /* @__PURE__ */ e(K, { ...r, order: t.order });
  })
);
export {
  b as OrderDetails,
  j as OrderDetailsSchema,
  g as PaymentDetails,
  E as PaymentDetailsSchema,
  U as SuccessPage,
  L as SuccessPageBarcelona,
  k as SuccessPageMadrid,
  B as SuccessPagePalma,
  K as TemplateSelector,
  R as mockOrder,
  P as successPageBarcelonaPropsSchema,
  _ as successPageMadridPropsSchema,
  y as successPagePalmaPropsSchema,
  N as templateSelectorSchema
};
//# sourceMappingURL=index.es.js.map
